import {isArray, isArrayHaveItem, mergeListSafe, removeItems} from "./listHelper";
import {isBlank} from "./stringHelper";
import isNumeric from "antd/lib/_util/isNumeric";
import _ from "lodash";

const stringConstructor = "test".constructor;
const arrayConstructor = [].constructor;
const objectConstructor = ({}).constructor;

export const typeOfString = "string";
export const typeOfArray = "array";
export const typeOfObject = "object";
export const typeOfMapEnum = "mapenum";
export const typeOfNumber = "number";
export const typeOfBoolean = "boolean";
export const typeOfDate = "date";
export const typeOfFunction = "function";
export const typeOfNull = "null";
export const typeOfBlob = "blob";
export const typeOfUndefined = "undefined";


export const VALUE_CREATED = 'created';
export const VALUE_UPDATED = 'updated';
export const VALUE_DELETED = 'deleted';
export const VALUE_UNCHANGED = 'unchanged';

export type objectTypes = "undefined" | "object" | "boolean" | "number" | "date" | "mapenum" | "string" | "function" | "symbol" | "bigint" | "null" | "array" |"blob";

export const isObjectThisType = (object: any, types: objectTypes): boolean => {
    return getTypeOfObject(object) === types;
}


const valueComparer = (value1: any, value2: any) => {
    if (value1 === value2) {
        return VALUE_UNCHANGED;
    }
    if (isDate(value1) && isDate(value2) && value1.getTime() === value2.getTime()) {
        return VALUE_UNCHANGED;
    }
    if (value1 === undefined) {
        return VALUE_CREATED;
    }
    if (value2 === undefined) {
        return VALUE_DELETED;
    }
    return VALUE_UPDATED;
};


export const getTypeOfObject = (object: any): objectTypes => {
    if (object === null) {
        return typeOfNull;
    }
    if (object === undefined) {
        return typeOfUndefined;
    }
    if (object.constructor === stringConstructor) {
        return typeOfString;
    }
    if (object.constructor === arrayConstructor) {
        return typeOfArray;
    }

    if (Object.prototype.toString.call(object) === '[object Function]') {
        return typeOfFunction;
    }

    if (Object.prototype.toString.call(object) === '[object MapEnum]') {
        return typeOfMapEnum;
    }
    if (Object.prototype.toString.call(object) === '[object Date]') {
        return typeOfDate;
    }
    if (Object.prototype.toString.call(object) === '[object Blob]') {
        return typeOfBlob;
    }
    if (object.constructor === objectConstructor) {
        return typeOfObject;
    }

    return typeof object;
}

export const getTypeOfObjectGroup = (object: any): "undefined" | "null" | "object" | "value" | "array" | "enum" => {

    switch (getTypeOfObject(object)) {
        case "undefined":
            return "undefined";
        case "object":
            return "object";
        case "blob":
            return "object";
        case "boolean":
            return "value"
        case "number":
            return "value"
        case "string":
            return "value"
        case "function":
            return "object";
        case "symbol":
            return "object";
        case "bigint":
            return "value"
        case "null":
            return "null";
        case "array":
            return "array";
        case "date":
            return "value";
        case "mapenum":
            return "enum";

    }
}
export const isObject = (myObject: any) => {
    return (myObject && myObject.constructor === Object);


};

export const isDate = (object: any): boolean => {
    return isObjectThisType(object, typeOfDate)
}
export const isFunction = (object: any): boolean => {
    return isObjectThisType(object, typeOfFunction)
}
export const isMapEnum = (object: any): boolean => {
    return isObjectThisType(object, typeOfMapEnum)
}
export const isNumber = (object: any): boolean => {
    return isObjectThisType(object, typeOfNumber)
}

export const isBoolean = (object: any): boolean => {
    return isObjectThisType(object, typeOfBoolean)
}

export const isString = (object: any): boolean => {
    return isObjectThisType(object, "string")
}


export const iObjectEmptyLodash = (values: object | undefined) => {
    return _.isEmpty(values);
};
export const isObjectEmpty = (myObject: any) => {
    if (myObject && myObject.constructor === Object) {
        for (let prop in myObject) {
            if (myObject.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    } else {
        return false;
    }


};

export const isObjectEmptyOrUndefined = (myObject: any) => {
    if (myObject && myObject.constructor === Object) {
        for (let prop in myObject) {
            if (myObject.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    } else {
        if (myObject === undefined) {
            return true;
        }
        return false;
    }


};
export const isObjectEmptyOrUndefined_2 = (myObject: any, ignoreProps: string[] = []) => {
    const checkProp = isArrayHaveItem(ignoreProps);
    if (myObject && myObject.constructor === Object) {
        for (let prop in myObject) {
            if (checkProp) {
                if (ignoreProps.indexOf(prop) < 0) {
                    if (myObject.hasOwnProperty(prop)) {
                        return false;
                    }
                }
            } else {
                if (myObject.hasOwnProperty(prop)) {
                    return false;
                }
            }

        }
        return true;
    } else {
        if (myObject === undefined) {
            return true;
        }
        return false;
    }


};
export const deleteKeyFromObject = (keyPart: string, srcObject: any) => {
    const keys = keyPart.split('.');// Loop through the object
    if (keys.length > 1) {

        let tempKey = '';
        let parentKey = '';
        const lastKeyIndex = keys.length - 1;
        let me = srcObject;
        let parentMe = srcObject;
        for (let i = 0; i < lastKeyIndex; ++i) {
            parentKey = tempKey;
            tempKey = keys[i];
            parentMe = me;
            me = me[tempKey];
            if (getTypeOfObject(me) !== "object") {
                return;
            }
        }
        for (const k in me) {
            if ( k.length === keys[lastKeyIndex]?.length &&(~k.indexOf(keys[lastKeyIndex]))) {
                delete me[k];
            }
        }
        if (Object.keys(me).length === 0 && parentKey !== '') {
            delete parentMe[tempKey];
        }
    } else {
        for (const k in srcObject) {
            if (k.length === keyPart?.length && (~k.indexOf(keyPart))) {
                delete srcObject[k];
            }
        }
    }


}
export const deleteKeysFromObject = (keysPart: string[], srcObject: any) => {
    keysPart.forEach(keyPart => {
        deleteKeyFromObject(keyPart, srcObject);
    })
}

export const dotObjectKeysConvertObject = (sourceObject: any, condition: (key: string, data: string) => boolean = (key, data) => {
    return true
}) => {
    const keys = Object.keys(sourceObject);
    const destObject = {};
    keys.forEach((key) => {
        if (sourceObject[key] !== undefined) {
            setObject(destObject, key, sourceObject[key], false, condition);
        }
    })
    return destObject;
}
export const setObject = (object: any, key: string, data: any, force: boolean, condition: (key: string, data: string) => boolean = (key, data) => {
    return true
}) => {

    let me = object;
    const keys = key.split('.');
    let tmpKey = '';
    if (keys.length > 1) {
        const lastKeyIndex = keys.length - 1;

        for (let i = 0; i < lastKeyIndex; ++i) {
            let valueIsArray = false;
            if (i + 1 < lastKeyIndex) {
                valueIsArray = isNumeric(keys[i + 1]);
            }
            const isIndex = isNumeric(keys[i]);
            if (isIndex) {
                const index = Number.parseFloat(tmpKey)
                if (isArray(me)) {
                    const array = me as any[];
                    if (index < array.length) {
                        me = array[index];
                    } else {
                        const setValue = valueIsArray ? [] : {};
                        array.push(setValue);
                        me = setValue;
                    }


                }
            } else {
                tmpKey = keys[i];
                const setValue = valueIsArray ? [] : {};
                if (force === undefined || !force) {
                    if (!(tmpKey in me)) {
                        me[tmpKey] = setValue;
                    }
                } else if (force) {
                    if(me[tmpKey] === undefined){
                        me[tmpKey] = setValue;
                    }
                }
                me = me[tmpKey];
            }

        }

        let tempData = {} as any;

        if (!force) {
            if (data === undefined || data === 'undefined') {
                tempData = me[keys[lastKeyIndex]];
            } else if (getTypeOfObject(me[keys[lastKeyIndex]]) === typeOfObject) {
                if (getTypeOfObject(data) === typeOfObject) {
                    tempData = Object.assign(me[keys[lastKeyIndex]], data);
                } else {
                    tempData = data;
                }

            } else if (getTypeOfObject(me[keys[lastKeyIndex]]) === typeOfArray) {
                if (getTypeOfObject(data) === typeOfArray) {
                    tempData = mergeListSafe(me[keys[lastKeyIndex]], data);
                } else if (data !== undefined) {
                    tempData = me[keys[lastKeyIndex]];
                    tempData.push(data);
                } else {
                    tempData = data;
                }

            } else {
                tempData = data;
            }
        } else {
            tempData = data;
        }
        /*if (!condition(key, tempData)) {
            return me;
        }*/
        if (tempData === undefined || tempData === null || tempData === 'undefined' || !condition(key, tempData)) {
            me[keys[lastKeyIndex]] = tempData;
        } else if (tempData.context && tempData.context.type === 'radio') {
            me[keys[lastKeyIndex] + tempData.val()] = tempData;
        } else if (tempData.context && tempData.context.type === 'checkbox') {
            me[keys[lastKeyIndex]] = tempData;
        } else {
            me[keys[lastKeyIndex]] = tempData;
        }

        return me;
    } else {
        if (data === undefined || data === 'undefined' || !condition(key, data)) {
            return me;
        }
        return (object[keys[0]] = data);
    }
}

export const convertObjectPathToDotKeys = (obj: any) => {
    const discoveredObjects = [] as any[];
    const path:any[] = [];
    const results = {} as any;
    if (!obj && (typeof obj !== 'object' || Array.isArray(obj))) {
        throw new TypeError('convertObjectPathToDotKeys should be type Object');
    }
    (function find(obj) {
        for (const key of Object.keys(obj)) {
            const value = obj[key];
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                if (!discoveredObjects.find((obj) => obj === value)) {
                    path.push(key);
                    discoveredObjects.push(value);
                    find(value);
                    path.pop();
                }
            } else {
                path.push(key);
                const pathAddress = path.join('.');
                results[pathAddress] = value;
                path.pop();
            }
        }
    })(obj);
    return results;
}
export const getDescendantProp = (obj: object | any, desc: string) => {
    if (isBlank(desc)) {
        return obj as any;
    }
    if (obj === null || obj === undefined) {
        return obj as any;
    }
    const newDesc = desc.replaceAll('?', '') as string
    const arr = newDesc.split('.') as any
    while (arr.length > 0) {
        obj = obj[arr.shift()]
        if (obj === undefined || obj === null) {
            return obj as any;
        }
    }
    return obj as any
};

export const clearEmptyObject = (srcObject: any) => {
    const checkField: string[] = [];
    Object.keys(srcObject).forEach(key => {
        const data = getDescendantProp(srcObject, key);
            if (isObjectEmptyOrUndefined(data)) {
                checkField.push(key);
            }
            else
            {
                const typeObject =  getTypeOfObject(data);
                if(typeObject === "object"){
                    clearEmptyObject(data);
                }
            }
        }
    );
    deleteKeysFromObject(checkField, srcObject);
}

export const clearObject = (srcObject:any)=>{
    if(isObject(srcObject)){
        if(!isObjectEmpty(srcObject)){
            for (let prop in srcObject) {
                if (srcObject.hasOwnProperty(prop)) {
                    delete srcObject[prop];
                }
            }
        }
    }

}


export const copyCheckEmptyObjectFilterProps = (obj: any, notCheckTheProps: string[] = [],checkEmptyObject:boolean = true) => {
    const discoveredObjects = [] as any[];
    const path:any[] = [];
    const results = {} as any;
    if (!obj && (typeof obj !== 'object' || Array.isArray(obj))) {
        throw new TypeError('convertObjectPathToDotKeys should be type Object');
    }
    (function find(obj) {
        for (const key of Object.keys(obj)) {
            const value = obj[key];
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                if ( !checkEmptyObject || (!isObjectEmptyOrUndefined_2(value, notCheckTheProps))) {
                    if (!discoveredObjects.find((obj) => obj === value)) {
                        path.push(key);
                        discoveredObjects.push(value);
                        find(value);
                        path.pop();
                    }
                }
            } else {
                path.push(key);
                const pathAddress = path.join('.');
                setObject(results, pathAddress, value, true);
                path.pop();
            }
        }
    })(obj);

    return results;
}
export const copyObject = (obj: any) => {
    return copyCheckEmptyObjectFilterProps(obj,[],false);
}
export const clearEmptyObjectFilterProps = (obj: any, ignoreProps: string[] = []) => {
    const discoveredObjects = [] as any[];
    const path:any[] = [];
    if (!obj && (typeof obj !== 'object' || Array.isArray(obj))) {
        throw new TypeError('should be type Object');
    }
    const results = (function find(obj) {
        for (const key of Object.keys(obj)) {
            const value = obj[key];
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                if (isObjectEmptyOrUndefined_2(value, ignoreProps)) {
                    delete obj[key];
                } else {
                    if (!discoveredObjects.find((obj) => obj === value)) {
                        path.push(key);
                        discoveredObjects.push(value);
                        if (find(value) === undefined) {
                            delete obj[key];
                        }
                        path.pop();
                    }
                }
            } else {
                path.push(key);
                path.pop();
            }
        }
        if (isObjectEmptyOrUndefined_2(obj, ignoreProps)) {
            return undefined;
        } else {
            return obj;
        }
    })(obj);
    return results;
}
export const getArrayDiff = (sourceObj: any, compareObj: any, ignoreProps: string[] = [],converter?:(value:any)=>any) => {
    if (isArray(sourceObj)) {
        if (isArray(compareObj)) {
            if (sourceObj.length === compareObj.length) {
                if (sourceObj.length > 0) {
                    const removeItemsIndex: number[] = [];
                    for (let i = 0; i < sourceObj.length; i++) {
                        const typeObject = getTypeOfObject(sourceObj[i]);
                        if (typeObject === "object") {
                            if(sourceObj[i]?.id === compareObj[i]?.id){
                                if (isObjectEmptyOrUndefined_2(getObjectDiff(sourceObj[i], compareObj[i],{ignoreProps,converter}), ignoreProps)) {
                                    removeItemsIndex.push(i);
                                }
                            }

                        } else if (typeObject === "array") {
                            getArrayDiff(sourceObj[i], compareObj[i],[],converter);
                        } else {
                            if (valueComparer(sourceObj[i], compareObj[i]) === VALUE_UNCHANGED) {
                                removeItems(sourceObj, removeItemsIndex);
                            }
                        }
                    }
                    removeItems(sourceObj, removeItemsIndex);
                }
            } else if (sourceObj.length < compareObj.length) {
                if (sourceObj.length > 0) {
                    getArrayDiff(sourceObj, (compareObj as any[]).slice(0, sourceObj.length),[],converter)
                }
            } else if (compareObj.length < sourceObj.length) {
                if (compareObj.length > 0) {
                    const diffCount = sourceObj.length - compareObj.length;
                    const diffArray = Array(diffCount).fill(undefined);

                    getArrayDiff(sourceObj, mergeListSafe(compareObj, diffArray),[],converter);
                }
            } else {

            }
        }
    }
}
export const getObjectDiff = (obj: any, compareObj: any,props?:{ignoreProps?: string[],converter?:(value:any)=>any,copyId?:boolean}) => {
    const {ignoreProps=[],converter,copyId=true} = props ?? {}
    const discoveredObjects = [] as any[];
    const path:any[] = [];
    if (!obj && (typeof obj !== 'object' || Array.isArray(obj))) {
        return obj;
    }
    const results = (function find(obj, compareObj) {
        for (const key of Object.keys(obj)) {
            let value = obj[key];
            const valueCompare = compareObj ? compareObj[key] : undefined;
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                value = {...value};
                obj[key] = value;
                if (isObjectEmptyOrUndefined_2(value, ignoreProps)) {
                    delete obj[key];
                } else {
                    if (!discoveredObjects.find((obj) => obj === value)) {
                        path.push(key);
                        discoveredObjects.push(value);
                        if (find(value, valueCompare) === undefined) {
                            delete obj[key];
                        }
                        path.pop();
                    }
                }
            } else if (isArray(value)) {
                if (value.length > 0) {
                    getArrayDiff(value, valueCompare, ignoreProps);
                }
                if (value.length === 0) {
                    delete obj[key];
                }
            } else {
                path.push(key);
                if (valueComparer(value, valueCompare) === VALUE_UNCHANGED) {
                    delete obj[key];
                }else{
                    if(converter){
                        obj[key] = converter(value);
                    }
                }
                path.pop();
            }
        }
        if (isObjectEmptyOrUndefined_2(obj, ignoreProps)) {
            return undefined;
        } else {
            const idValueCompare = compareObj ? compareObj["id"] : undefined;
            const idValueObj = obj ? obj["id"] : undefined;
            if (idValueObj === undefined && idValueCompare !== undefined) {
                if(copyId){
                    obj["id"] = idValueCompare;
                }
            }
            return obj;
        }
    })(obj, compareObj);
    return results;
}


